module.exports = __webpack_public_path__ + "static/media/Corporate-&-Mergers-and-Acquisitions.a8357b71.jpg";